export default "__VITE_ASSET__B5p$mkSe__ 1200w";